import * as IsEmailPackage from "isemail";
import tlds from "tlds";
export const isEmail = (emailToCheck, options = {}) => {
    if (!emailToCheck) {
        return false;
    }
    if (options.validateOnlyLocalPart) {
        emailToCheck = `${emailToCheck}@example.com`;
    }
    return IsEmailPackage.validate(emailToCheck, {
        minDomainAtoms: 2,
        tldWhitelist: tlds,
        ...options,
    });
};
export default isEmail;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW1haWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdmFsaWRhdGlvbi9lbWFpbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssY0FBYyxNQUFNLFNBQVMsQ0FBQztBQUMxQyxPQUFPLElBQUksTUFBTSxNQUFNLENBQUM7QUFZeEIsTUFBTSxDQUFDLE1BQU0sT0FBTyxHQUFHLENBQ3JCLFlBQWdDLEVBQ2hDLFVBQTBCLEVBQUUsRUFDbkIsRUFBRTtJQUNYLElBQUksQ0FBQyxZQUFZLEVBQUUsQ0FBQztRQUNsQixPQUFPLEtBQUssQ0FBQztJQUNmLENBQUM7SUFFRCxJQUFJLE9BQU8sQ0FBQyxxQkFBcUIsRUFBRSxDQUFDO1FBQ2xDLFlBQVksR0FBRyxHQUFHLFlBQVksY0FBYyxDQUFDO0lBQy9DLENBQUM7SUFFRCxPQUFPLGNBQWMsQ0FBQyxRQUFRLENBQUMsWUFBWSxFQUFFO1FBQzNDLGNBQWMsRUFBRSxDQUFDO1FBQ2pCLFlBQVksRUFBRSxJQUFJO1FBQ2xCLEdBQUcsT0FBTztLQUNYLENBQUMsQ0FBQztBQUNMLENBQUMsQ0FBQztBQUVGLGVBQWUsT0FBTyxDQUFDIn0=